import { useState } from 'react';
import { ServicesEditor } from './ServicesEditor.tsx';
import { OffersEditor } from './OffersEditor.tsx';

interface TreatmentsPanelProps {
  token: string;
  onUnauthorised: () => void;
}

type View = 'treatments' | 'offers';

/**
 * The menu, and the offers running against its prices.
 *
 * One tab rather than two, because the top-level nav is already wide on a phone
 * and both answer "what does the website say a treatment costs". The treatments
 * come first, being the daily job; categories stay where they are, inside the
 * treatment editor.
 */
export function TreatmentsPanel({ token, onUnauthorised }: TreatmentsPanelProps) {
  const [view, setView] = useState<View>('treatments');

  return (
    <section className="page stack-lg">
      <div className="segmented" role="group" aria-label="Treatment menu section">
        <button
          type="button"
          className={`segmented__option ${view === 'treatments' ? 'segmented__option--active' : ''}`}
          onClick={() => setView('treatments')}
        >
          Treatments
        </button>
        <button
          type="button"
          className={`segmented__option ${view === 'offers' ? 'segmented__option--active' : ''}`}
          onClick={() => setView('offers')}
        >
          Offers
        </button>
      </div>

      {view === 'treatments' ? (
        <ServicesEditor token={token} onUnauthorised={onUnauthorised} />
      ) : (
        <OffersEditor token={token} onUnauthorised={onUnauthorised} />
      )}
    </section>
  );
}
